import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { DocumentEditPageComponent } from '../documents/document-edit/document-edit-page.component';

@Injectable({
  providedIn: 'root',
})
export class CheckChangesGuard  {
  canDeactivate(
    component: DocumentEditPageComponent,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return component.checkChanges(nextState);
  }
}
